var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66699 12.3333C11.6125 12.3333 14.0003 9.9455 14.0003 6.99998C14.0003 4.05446 11.6125 1.66665 8.66699 1.66665C5.72147 1.66665 3.33366 4.05446 3.33366 6.99998H2.00033C2.00033 3.31808 4.98509 0.333313 8.66699 0.333313C12.3489 0.333313 15.3337 3.31808 15.3337 6.99998C15.3337 10.6819 12.3489 13.6666 8.66699 13.6666V12.3333ZM8.33366 6.7743V4.33331H7.66699V6.99998V7.22566L7.87653 7.30947L11.2099 8.64281L11.4575 8.02382L8.33366 6.7743ZM0.666992 7.00004L2.66699 9.40005L4.66699 7.00004H0.666992Z",
    fill: "#597796"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.d6a6160bfc9681c4869f240e4c00de8a.svg";
export { ForwardRef as ReactComponent };